import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* High-quality background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6340e050be667c776667054e408ebf23.jpg"
          alt="Surfer repairing surfboard in sunlight on beach"
          className="w-full h-full object-cover object-top"
        />
        {/* Darker gradient overlay for contrast */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/25" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/40" />
      </div>

      {/* Warm sun glow particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 right-1/3 w-80 h-80 bg-[#FF6B35]/12 rounded-full blur-3xl animate-pulse" />
        <div className="absolute top-1/2 right-1/4 w-56 h-56 bg-yellow-500/8 rounded-full blur-2xl animate-pulse delay-700" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-24 pb-20 w-full">
        <div className="max-w-2xl">
          {/* Eyebrow badge */}
          <div className="inline-flex items-center gap-2 bg-[#FF6B35]/25 border border-[#FF6B35]/50 rounded-full px-4 py-1.5 mb-7 backdrop-blur-sm">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-sun-fill text-[#FF6B35] text-sm" />
            </div>
            <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">Sun-Powered UV Cure Technology</span>
          </div>

          {/* H1 — stronger focus */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[1.03] mb-6">
            Sun-Powered<br />
            <span className="text-[#FF6B35]">Repair</span> in<br />
            <span className="text-[#FF6B35]">Minutes</span>.<br />
            Not Days.
          </h1>

          {/* Sub — benefit-driven */}
          <p className="text-white/80 text-lg md:text-xl font-medium mb-4 leading-relaxed max-w-lg">
            Professional-grade surfboard ding repair kits that cure in direct sunlight. No shop. No downtime. Works on epoxy and poly boards.
          </p>

          {/* Urgency line */}
          <div className="flex items-center gap-2 mb-8">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-alarm-warning-line text-[#FF6B35] text-sm" />
            </div>
            <span className="text-[#FF6B35] text-sm font-semibold">Don&apos;t miss your next session — repairs take minutes, not days</span>
          </div>

          {/* Dual CTAs */}
          <div className="flex flex-wrap gap-4">
            <Link
              to="/products"
              className="whitespace-nowrap bg-[#FF6B35] text-white font-black text-base px-8 py-4 rounded-full hover:bg-[#e55a25] transition-all duration-200 cursor-pointer flex items-center gap-2"
            >
              <i className="ri-shopping-bag-line" />
              Shop Kits Now
            </Link>
            <a
              href="#how-it-works"
              className="whitespace-nowrap bg-white/18 backdrop-blur-sm border border-white/45 text-white font-bold text-base px-8 py-4 rounded-full hover:bg-white/28 transition-all duration-200 cursor-pointer flex items-center gap-2"
            >
              <i className="ri-play-circle-line" />
              How It Works
            </a>
          </div>

          {/* Social proof */}
          <div className="flex items-center gap-6 mt-10 flex-wrap">
            <div className="flex -space-x-3">
              {['s1', 's2', 's3', 's4'].map((k, i) => (
                <div key={k} className="w-9 h-9 rounded-full border-2 border-white overflow-hidden">
                  <img
                    src={`https://readdy.ai/api/search-image?query=surfer%20face%20portrait%20athletic%20beach%20lifestyle%20person&width=40&height=40&seq=sp${i + 10}&orientation=squarish`}
                    alt="Surfer"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              ))}
            </div>
            <div>
              <div className="flex gap-0.5 mb-0.5">
                {[1, 2, 3, 4, 5].map((s) => (
                  <i key={s} className="ri-star-fill text-yellow-400 text-xs" />
                ))}
              </div>
              <p className="text-white/80 text-sm"><strong className="text-white">40,000+</strong> surfers in 60+ countries</p>
            </div>
            <div className="hidden sm:flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-3 py-1.5">
              <i className="ri-gift-line text-[#FF6B35] text-sm" />
              <span className="text-white text-xs font-semibold">Free Micro Kit on orders $40+</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom feature strip */}
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent py-5 px-6">
        <div className="max-w-7xl mx-auto flex flex-wrap gap-x-8 gap-y-2">
          {['Cures in 1–3 min sunlight', 'Works on all board types', 'Travel-safe, TSA approved', 'Endless shelf life'].map((item) => (
            <div key={item} className="flex items-center gap-2 text-white/80 text-sm">
              <i className="ri-check-line text-[#FF6B35] text-sm" />
              {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
